import React from 'react'

const Shadow = props => {
  return (
    <svg
      width={'657'}
      height={'44'}
      viewBox={'0 0 657 44'}
      fill={'none'}
      xmlns={'http://www.w3.org/2000/svg'}
      className={props.classes}
    >
      <ellipse
        cx={'328.5'}
        cy={'22'}
        rx={'328.5'}
        ry={'22'}
        fill={'#514C5E'}
        fillOpacity={'0.1'}
      />
    </svg>
  )
}

export default Shadow
